import React from "react";

class TemplatesListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { image, title, description, actionButton, actionButtonClick, onClick} = this.props;

        return (
            <div className="template-list-item" onClick={onClick}>
                {image ? <div className="image">{image}</div> : ""}
                {title || description ? (
                    <div className="template-content">
                        {title ? <div className="title">{title}</div> : ""}
                        {description ? <div className="description">{description}</div> : ""}
                    </div>
                ) : (
                    ""
                )}
                {actionButton ? (
                    <div
                        className="actionButton"
                        onClick={actionButtonClick ? () => actionButtonClick() : undefined}
                    >
                        {actionButton}
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default TemplatesListItem;